const NHCX_ACTION_TYPES = {
  SET_PAYER_DROPDOWN: 'SET_PAYER_DROPDOWN',
  SET_MEMBER_NAME: 'SET_MEMBER_NAME',
  GET_POLICY_SEARCH_RESULTS: 'GET_POLICY_SEARCH_RESULTS',
  SET_POLICY_SEARCH_RESULTS: 'SET_POLICY_SEARCH_RESULTS',
  SET_SELECTED_POLICY_DETAIL: 'SET_SELECTED_POLICY_DETAIL',
  GET_IPO_DETAILS: 'GET_IPO_DETAILS',
  SET_IPO_ID: 'SET_IPO_ID',
  SET_COVERAGE_ID: 'SET_COVERAGE_ID',
  SET_IPO_RESPONSE: 'SET_IPO_RESPONSE',
  SET_COVERAGE_RESPONSE: 'SET_COVERAGE_RESPONSE',
  CLEAR_NHCX_STATE: 'CLEAR_NHCX_STATE',
  SET_TOTAL_AMOUNT: 'SET_TOTAL_AMOUNT',
  SET_NOTIFY_MODAL: 'SET_NOTIFY_MODAL',
  GET_NHCX_RESPONSE: 'GET_NHCX_RESPONSE',
  SET_CARD_CHANGED: 'SET_CARD_CHANGED',
  SET_SHOW_OTP_SCREEN: 'SET_SHOW_OTP_SCREEN',
  SAVE_PARTICIPANT: 'SAVE_PARTICIPANT',
  CONFIRM_PARTICIPANT: 'CONFIRM_PARTICIPANT',
  GET_PARTICIPANT_DETAILS: 'GET_PARTICIPANT_DETAILS',
  SET_PARTICIPATION_CREATED: 'SET_PARTICIPATION_CREATED',
  FETCH_FACILITY_REGISTRY: 'FETCH_FACILITY_REGISTRY',
  UPDATE_CERTIFICATES: 'UPDATE_CERTIFICATES',
  ROLLOUT_PAYERS_NHCX: 'ROLLOUT_PAYERS_NHCX',
  SET_RADIO_VALUE: 'SET_RADIO_VALUE',
  SET_IF_PARTICIPANT_EXISTING: 'SET_IF_PARTICIPANT_EXISTING',
};

export default NHCX_ACTION_TYPES;
